import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import "../../../Assets/Css/AddEmpProject.scss";

const initialState = {
    title: null,
};

function AddEmpProjectMoal({ isModalVisible, closeModal }) {
    const [clientData, setClientData] = useState(initialState);

    return (
        <Modal show={isModalVisible} onHide={closeModal} size="lg" aria-labelledby="contained-modal-title-vcenter" centered className="custom-modal">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className='heading'>Add Request For Project</h5>
                    <button className="btn-close" onClick={closeModal}></button>
                </div>
                <div className="modal-body">
                    <div className='add-department-container'>
                        <div className='add-information-part'>
                            <div className='form-part'>
                                <form>
                                    <div className="form-group">
                                        <div className='row'>
                                            <div className="col-lg-12">
                                                <div className="input-group">
                                                    <h6 className='label'>Project Name</h6>
                                                    <input type="text" className="input-css" name='projectname' placeholder='Project Name' />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="input-group">
                                                    <h6 className='label'>Reason</h6>
                                                    <input type="text" className="input-css" name='reason' placeholder='Reason' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer d-flex justify-content-end">
                    <button className="btn-cancel" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn-save" onClick={closeModal}>
                        Add Request For Project
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default AddEmpProjectMoal;
